import { connect } from 'react-redux'
import { Column } from 'primereact/column'
import { DataTable } from 'primereact/datatable'
import React, { useEffect } from 'react'
import { withRouter } from 'react-router'
import { tableCellCentered } from '../../../../assets/js/styles'
import { CustomDataTableHeader, CustomPanel, PageHeader, ThreeDots } from '../../../../components'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import useCompaniesGroup, { LOAD_MESSAGE } from './CompaniesGroupHook'
import ModalCompanyGroup from './ModalCompanyGroup/ModalCompanyGroup'
import ModalAssocCompanies from './ModalAssocCompanies/ModalAssocCompanies'

function CompaniesGroup({ dispatch, history, selectedTp }) {
  const { state, localDispatch } = useCompaniesGroup()

  useEffect(() => {
    localDispatch.onInit()
  }, [])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break

      case LOAD_MESSAGE.GET_COMPANIES_GROUPS:
        dispatch(showLoadingBox())
        localDispatch.getCompaniesGroupWithItems()
        break

      case LOAD_MESSAGE.DELETE_COMPANY_GROUP:
        dispatch(showLoadingBox())
        localDispatch.deleteCompanyGroup(state.selectedCompanyGroup.id)
        break

      case LOAD_MESSAGE.DELETE_SUCCESS:
        dispatch(hideLoadingBox())
        dispatch(showMessageBox(state.loadingMessage, null))
        break

      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  return (
    <>
      <PageHeader>S.16 - Grupo de Empresas</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel onNovo={() => localDispatch.onBtnNovo()} onVoltar={history.goBack}>
          <DataTable
            value={state.companiesGroup}
            paginator
            rows={10}
            globalFilter={state.globalFilter}
            header={<CustomDataTableHeader onChange={localDispatch.onGlobalFilterChange} />}
          >
            <Column field="id" header="Código" style={{ textAlign: 'center', width: 80 }} />
            <Column field="name" header="Grupo de Companhia" />
            <Column
              header="Menu"
              style={tableCellCentered(70)}
              body={company => (
                <ThreeDots
                  items={['Apagar', 'Editar', 'Assoc. Empresas']}
                  onClick={item => localDispatch.onMenuItemClicked(item, company)}
                />
              )}
              bodyStyle={tableCellCentered()}
            />
          </DataTable>
        </CustomPanel>
      </div>
      <ModalCompanyGroup
        data={state.modalEdit.data}
        show={state.modalEdit.show}
        onModalClose={() => localDispatch.onModalClose('edit')}
        onModalSave={payload => localDispatch.onModalSave('edit', payload)}
      />
      <ModalAssocCompanies
        data={state.modalAssoc.data}
        show={state.modalAssoc.show}
        onModalClose={() => localDispatch.onModalClose('assoc')}
        onModalSave={payload => localDispatch.onModalSave('assoc', payload)}
      />
    </>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(withRouter(CompaniesGroup))
